import style from './Submissions.module.css';
import {Link} from 'react-router-dom';
import {Modal} from 'react-bootstrap';
import React from "react";
import CompanyIcon from './../../../assets/icons/Company2.svg';
import {Loading} from "../../../components/Loading/Loading";
import moment from 'moment'
interface Props {
    Open?: boolean,
    ModalLoad?: boolean,
    setOpen?: any,
    Jop?: {
        appointment?: {date:string,address:string},
        createdAt: string,
        companyId: string,
        companyImage: string,
        companyName: string,
        form: Array<{
            question: string, answer: string
        }>,
        id: string,
        jobId: string,
        jobName: string,
        status: string,
        updatedAt: string,
    },
}

export const ModalSubmit: React.FC<Props> = (props) => {
    function formatAMPM(time: string) {
        let date = new Date(time);
        let hours: number = date.getHours();
        let minutes: string | number = date.getMinutes();
        let ampm = hours >= 12 ? 'م' : 'ص';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        let ardata = date.toLocaleDateString('ar-EG-u-nu-latn', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        }).toString()
        return hours + ':' + minutes + ampm + ' , ' + ardata;
    }

    return (<>
        <Modal
                show={props.Open}
                onHide={() => props.setOpen(false)}
                aria-labelledby="contained-modal-title-vcenter"
                centered

        >


            <Modal.Header>
                <div className={'rtl w-100 d-flex justify-content-between'}>

                    <div className={style.ModalTitle}>طلب التوظيف</div>
                    <button className={'btn ' + style.btnClose} onClick={() => props.setOpen(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" x="0" y="0"
                             viewBox="0 0 365.71733 365">
                            <g>
                                <g xmlns="http://www.w3.org/2000/svg" fill="#f44336">
                                    <path
                                            d="m356.339844 296.347656-286.613282-286.613281c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503906-12.5 32.769532 0 45.25l286.613281 286.613282c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082032c12.523438-12.480468 12.523438-32.75.019532-45.25zm0 0"
                                            fill="#f44336" data-original="#f44336" className=""></path>
                                    <path
                                            d="m295.988281 9.734375-286.613281 286.613281c-12.5 12.5-12.5 32.769532 0 45.25l15.082031 15.082032c12.503907 12.5 32.769531 12.5 45.25 0l286.632813-286.59375c12.503906-12.5 12.503906-32.765626 0-45.246094l-15.082032-15.082032c-12.5-12.523437-32.765624-12.523437-45.269531-.023437zm0 0"
                                            fill="#f44336" data-original="#f44336" className=""></path>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>

            </Modal.Header>
            <Modal.Body>
                {!props.ModalLoad && props.Jop ? (
                        <div className={" rtl d-flex flex-column animate__animated animate__fadeIn"}>
                            <div className={'d-flex align-items-center justify-content-between py-0 my-0'}>
                                <Link className={style.ModaljT}
                                      to={`/employee/job/${props.Jop.jobId}`}>{props.Jop.jobName}</Link>


                                <p className={" my-0 " + style.stateModal}
                                   style={{
                                       background: props.Jop.status === "SENT" ? '#395F74' :
                                               props.Jop.status === "ACCEPT" ? '#29793A' : props.Jop.status === "SEEN" ? '#9E7E0B' : props.Jop.status === "REJECT" ? '#922424' : ""
                                   }}
                                   title={props.Jop.status === "SENT" ? 'تم الإرسال' :
                                           props.Jop.status === "ACCEPT" ? 'تم تحديد موعد المقابلة' : props.Jop.status === "SEEN" ? 'تم رؤية الطلب' : props.Jop.status === "REJECT" ? 'مرفوض' : ""}> {props.Jop.status === "SENT" ? 'تم الإرسال' :
                                        props.Jop.status === "ACCEPT" ? 'تم تحديد موعد المقابلة' : props.Jop.status === "SEEN" ? 'تم رؤية الطلب' : props.Jop.status === "REJECT" ? 'مرفوض' : ""}</p>


                            </div>

                            <div className={'d-flex flex-column align-items-start   '}>
                                <Link to={`/company/${props.Jop.companyId}`}
                                      className={'d-flex align-items-center ' + style.CompanyLink}>

                                    <img
                                            className={style.ImgCompanyLogo + ` ${props.Jop.companyImage ? (style.ObjectFitFill) : (style.ObjectFitNone)}`}
                                            height={'25px'} width={'25px'} alt={props.Jop.companyName}
                                            src={props.Jop.companyImage ? props.Jop.companyImage : CompanyIcon}/>
                                    <p className={style.companyname + " p-0 mx-2 m-0"}>{props.Jop.companyName}</p>
                                </Link>
                                <p className={style.date + ' m-0 p-0'}>وقت التقديم:<span
                                        className={'px-2'}>{formatAMPM(props.Jop.createdAt)}</span></p>
                            </div>
                            {props.Jop.form && props.Jop.form.length > 0 ? (
                                    <div className={'d-flex flex-column mt-4'}>
                                        <h5 className={'mb-2'}>اسئلة المعلن عن الوظيفة</h5>
                                        {props.Jop.form.map((QaData: any, index: number) => (
                                                <div key={index} className={' d-flex flex-column my-1'}>
                                                    <div className={'d-flex justify-content-between align-items-center m-0 p-0'}>
                                                        <p className={"p-0 m-0 my-1"}>{QaData.question}</p>

                                                    </div>
                                                    <div>
                                                        <div className={style.InputAnswer + ' form-control   m-0 '} style={{boxSizing: 'border-box'}}>
                                                            {QaData.answer}
                                                        </div>
                                                    </div>

                                                </div>
                                        ))}
                                    </div>) : null}


                            { props.Jop.status === "ACCEPT" &&  props.Jop.appointment&&(
                                    <div className={'d-flex flex-column mt-4'}>
                                        <h5 className={'mb-2'}>موعد و مكان المقابلة</h5>
                                        <div className={'d-flex flex-column justify-content-center align-items-center'}>
                                            <div className={style.InputAnswer + ' form-control my-2  m-0 w-75 '} style={{boxSizing: 'border-box'}}>
                                                {moment(new Date(props.Jop.appointment.date)).format('h:mm a, Do MMMM YYYY')}

                                            </div>
                                            <div className={style.InputAnswer + ' form-control  my-2 m-0 w-75 '} style={{boxSizing: 'border-box'}}>
                                                {props.Jop.appointment.address}
                                            </div>
                                        </div>

                                    </div>

                            )}

                        </div>
                ) : (<div className={"d-flex w-100 justify-content-center align-items-center"}>
                    <Loading color=" rgba( 29 , 37 , 45 , 0.5) " smhight foregroundColor="#6C757D" width={150}/>
                </div>)}

            </Modal.Body>

        </Modal>
    </>)
}